<template>
  <div class="p-4 bg-gray-50 min-h-screen">
    <div class="flex justify-between items-center mb-6">
      <h1 class="text-2xl font-bold">Moth Control</h1>
    </div>
    <MothControl />
  </div>
</template>

<script setup>
import MothControl from '@/components/MothControl.vue'
</script>
